






































import { sortBy } from 'lodash'
import { Vue, Component, Prop } from 'vue-property-decorator'

import FilterControls from './FilterControls.vue'

@Component({ components: { FilterControls } })
export default class EditableTable extends Vue {

	@Prop() items!: any[]
	@Prop() columns!: string[]
	@Prop() editing!: symbol | string | null
	@Prop() newSymbol!: symbol

	sortBy = 'id'
	sortAsc = true

	filters: { [key: string]: string } = {}

	get editingItem() {
		return this.editing !== null ? this.items.find(item => item.id === this.editing) : null
	}

	get sortedItems() {
		let filtered = this.items
		if(Object.keys(this.filters).length) {
			filtered = this.items.filter(item => {
				return !Object.keys(this.filters).some(key => {
					return !this.filterValue(item[key]).includes(this.filters[key].toLowerCase())
				})
			})
		}
		const sorted = sortBy(filtered, this.sortBy)
		return this.sortAsc ? sorted : sorted.reverse()
	}

	filterValue(val: any): string {
		if(typeof val === 'string') {
			return val.toLowerCase()
		} else if(typeof val === 'boolean') {
			// boolean data type will match the strings 'true' or 'false'
			return val ? 'true' : 'false'
		}
		// any other data types will not match any filters
		return ''
	}

	columnLabel(str: string) {
		let sorting = ''
		if(this.sortBy === str) {
			sorting = ' ' + (this.sortAsc ? '▾' : '▴')
		}
		return str[0].toUpperCase() + str.substr(1) + sorting
	}

	changeSort(col: string, asc: boolean) {
		this.sortBy = col
		this.sortAsc = asc
		this.$root.$emit('bv::hide::popover')
	}

	filter(filterText: string, col: string) {
		if(!filterText) {
			delete this.filters[col]
		} else {
			this.filters[col] = filterText
		}
		this.filters = { ...this.filters }
		this.$root.$emit('bv::hide::popover')
	}

	created() {
		this.sortBy = this.columns[0]
	}

}
